// import Chart from "chart.js/auto";
import { Line } from "react-chartjs-2";
import { useState, useEffect, useRef } from "react";

const UsersLineChart = () => {
  const chartRef = useRef();
  const [gradientValue, setGradientValue] = useState("");
  useEffect(() => {
    const ctx = chartRef.current.canvas.getContext("2d");
    const gradient = ctx.createLinearGradient(0, 0, 0, 400);
    gradient.addColorStop(0, "#84d1fea7");
    gradient.addColorStop(0.8, "#ffffff00");
    console.log("gradient", gradient);
    setGradientValue((prev) => gradient);
  }, []);
  return (
    <Line
      ref={chartRef}
      data={{
        labels: [23, 43, 20, 50, 34, 57], // x axis
        datasets: [
          {
            type: "bar",
            label: "",
            fill: true,
            backgroundColor: "#0183d0",
            data: [23, 43, 20, 50, 34, 57],
            borderColor: "#0183d0",
            radius: 1,
            borderWidth: 1,
            barThickness: 30,
            pointBorderWidth: 1,
            tension: 0.4,
          },
        ],
      }}
      options={{
        maintainAspectRatio: false,
        responsive: true,
        plugins: {
          legend: false,
          title: {
            display: false,
          },
          tooltip: {
            // callbacks: {
            //   label: function (tooltipItem, data) {
            //     return numFormtter(parseInt(tooltipItem.parsed.y));
            //   },
            // },
          },
        },
        scales: {
          x: {
            display: false,
            grid: {
              display: false,
            },
          },
          y: {
            display: true,
            grid: {
              display: true,
              borderDash: [10],
              borderDashOffset: 20,
              borderWidth: 0,
              color: "#eee",
            },
          },
        },
      }}
    />
  );
};

export default UsersLineChart;
